var _rect, _line, _line2, _line3, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignCenterVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    id: "align-center-vertical",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 224.005,
    x2: 204.005,
    y1: 128,
    y2: 128,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52.005,
    x2: 32.005,
    y1: 128,
    y2: 128,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 148.005,
    x2: 108.005,
    y1: 128,
    y2: 128,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 56,
    x: 112,
    y: 100,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    rx: 8,
    transform: "rotate(90 176 128)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 176,
    x: 52,
    y: 40,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    rx: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenterVertical);
export default __webpack_public_path__ + "static/media/align-center-vertical.b6db7636e22e81a0ec6d0096e18152d9.svg";
export { ForwardRef as ReactComponent };